import client from "./sharedoClient";

const validate = expression => client.post("/api/graph/scripting/validate", { expression, latestVersion: true });

export default {
    validate
};